<template>
<div class="object-table">
    <div v-for="(column, index) in displayObject.info" v-bind:key="`${column.attribute}_${index}`" class="object-data-row">
        <div class="data-cell-header b-column" :class="extendedCellClass" :title="column.alias">{{column.alias}}</div>
        <div class='data-cell' :class="extendedCellClass">
            <template v-if="column.media?.isPhoto">
                <image-viewer v-if=" column.media?.photo && column.media?.photo?.src != null" :src="column.media?.photo?.src">
                    <feedback-image-viewer
                        v-if="column.media.photo"
                        :value="column.media.photo.src"
                        :enableRemove="false"
                        title="Foto weergave"
                        style="cursor: pointer;"
                    />
                </image-viewer>
                <span v-else>{{ $t('photoNotAvailable') }}</span>
            </template>
            <template v-else-if="column.media?.link">
                <a :href="column.media?.link.href" :target="column.media?.link.extern ? '_blank' : '_self'">
                    <template v-if="column.media?.link.src">
                        <img class="detailimage" :src="column.media?.link.src" alt="hyperlink image" />
                    </template>
                    <template v-else>
                        {{column.displayValue}}
                    </template>
                </a>
            </template>
            <template v-else-if="column.hyperlink && !column.hyperlinkImage">
                <a :href="column.displayValue" :target="column.openExtern ? '_blank' : '_self'">
                    <template v-if="column.hyperlinkText">
                        {{column.hyperlinkText}}
                    </template>
                    <template v-else-if="column.value">
                        {{column.value}}
                    </template>
                    <template v-else>
                        {{column.displayValue}}
                    </template>
                </a>
            </template>
            <template v-else-if="column.hyperlink && column.hyperlinkImage">
                <a :href="column.displayValue" :target="column.openExtern ? '_blank' : '_self'">
                    <img class="detailimage"
                         :src="column.displayValue"
                         alt="hyperlink image"
                    />
                </a>
            </template>
            <template v-else>
                {{column.displayValue}}
            </template>
        </div>
    </div>
</div>
</template>

<script>
    import FeedbackImageViewer from '../../../FeedbackImageViewer.vue';
    import ImageViewer from '../../../BaseComponents/ImageViewer';

    export default {
        components: {
            'feedback-image-viewer': FeedbackImageViewer,
            'image-viewer': ImageViewer
        },
        props: {
            displayObject: { type: Object, required: true },
            extendedCellClass: { type: String, required: false }
        }
    };
</script>

<style lang="scss" scoped>
    .object-table {
        display: table;
        table-layout: fixed;
        width: 100%;
    }
    .object-data-row {
        display: table-row;
    }
    .data-cell-header {
        display: table-cell;
        text-align: left;
        font-weight: normal;
        font-size: 90%;
        padding: 4px 5px 2px 5px;
        vertical-align: top;
        line-height: 25px;
        width: 50%;
        word-wrap: initial;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .data-cell {
        display: table-cell;
        overflow-wrap: break-word;
        word-break: break-word;
        text-align: left;
        font-weight: bold;
        font-size: 100%;
        vertical-align: middle;
        padding: 4px 5px 2px 5px;
        line-height: 25px;
        width: 50%;
    }
</style>
